import MobileDetect from 'mobile-detect';

export const MobileDetector = {
  isMobile() {
    const md = new MobileDetect(window.navigator.userAgent);
    return !!md.mobile();
  },
};
